<template>
  <div v-if="show">
    <highcharts :options="chartOptions"/>
    <hr>
    <highcharts :options="chartOptions2"/>
    <hr>
    <highcharts :options="chartOptions3"/>
  </div>
</template>

<script>
  import {Chart} from 'highcharts-vue'

  export default {
    components: {
      highcharts: Chart
    },
    props: ['records'],
    data() {
      return {
        show: false,
        chartOptions: {
          chart: {
            type: 'spline'
          },
          title: {
            text: 'Все заявки'
          },
          xAxis: {},
          yAxis: {
            title: {
              text: 'Количество'
            },
          },
          tooltip: {
            crosshairs: true,
            shared: true
          },
          plotOptions: {
            spline: {
              marker: {
                radius: 4,
                lineColor: '#666666',
                lineWidth: 1
              }
            }
          },
          series: [
            //   {
            //   name: 'Tokyo',
            //   marker: {
            //     symbol: 'square'
            //   },
            //   data: [7.0, 6.9, 9.5, 14.5, 18.2, 21.5, 25.2, {
            //     y: 26.5,
            //     marker: {
            //       symbol: 'url(https://www.highcharts.com/samples/graphics/sun.png)'
            //     }
            //   }, 23.3, 18.3, 13.9, 9.6]
            //
            // },
            {
              name: 'London',
              marker: {
                symbol: 'diamond'
              },
              data: [4.2, 5.7, 8.5, 11.9, 15.2, 17.0, 16.6, 14.2, 10.3, 6.6, 4.8]
            }
          ]
        },
        chartOptions2: {
          chart: {
            type: 'spline'
          },
          title: {
            text: 'Почтовые заявки'
          },
          xAxis: {},
          yAxis: {
            title: {
              text: 'Количество'
            },
          },
          tooltip: {
            crosshairs: true,
            shared: true
          },
          plotOptions: {
            spline: {
              marker: {
                radius: 4,
                lineColor: '#666666',
                lineWidth: 1
              }
            }
          },
          series: []
        },
        chartOptions3: {
          chart: {
            type: 'spline'
          },
          title: {
            text: 'Доставочные заявки'
          },
          xAxis: {},
          yAxis: {
            title: {
              text: 'Количество'
            },
          },
          tooltip: {
            crosshairs: true,
            shared: true
          },
          plotOptions: {
            spline: {
              marker: {
                radius: 4,
                lineColor: '#666666',
                lineWidth: 1
              }
            }
          },
          series: []
        },
      }
    },
    mounted() {
      this.chartOptions.xAxis.categories = [];
      this.chartOptions2.xAxis.categories = [];
      this.chartOptions3.xAxis.categories = [];
      this.chartOptions.series = [];
      this.chartOptions2.series = [];
      this.chartOptions3.series = [];
      let dataRecords = {
        'all':{},
        'post':{},
        'delivery':{}
      };
      Object.keys(this.records).forEach((k) => {
        this.chartOptions.xAxis.categories.push(this.records[k].name);
        this.chartOptions2.xAxis.categories.push(this.records[k].name);
        this.chartOptions3.xAxis.categories.push(this.records[k].name);
        Object.keys(this.records[k].data.all).forEach((kd) => {
          if (!dataRecords.all[kd]){
            dataRecords.all[kd] = {
              name: (kd == 0 ? 'Поступили' : 'Закрыты'),
              data: []
            }
          }
          dataRecords.all[kd].data.push(this.records[k].data.all[kd]);
        })
        Object.keys(this.records[k].data.post).forEach((kd) => {
          if (!dataRecords.post[kd]){
            dataRecords.post[kd] = {
              name: (kd == 0 ? 'Поступили' : 'Закрыты'),
              data: []
            }
          }
          dataRecords.post[kd].data.push(this.records[k].data.post[kd]);
        })
        Object.keys(this.records[k].data.delivery).forEach((kd) => {
          if (!dataRecords.delivery[kd]){
            dataRecords.delivery[kd] = {
              name: (kd == 0 ? 'Поступили' : 'Закрыты'),
              data: []
            }
          }
          dataRecords.delivery[kd].data.push(this.records[k].data.delivery[kd]);
        })
      });
      Object.keys(dataRecords.all).forEach((k) => {
        this.chartOptions.series.push(dataRecords.all[k]);
      })
      Object.keys(dataRecords.post).forEach((k) => {
        this.chartOptions2.series.push(dataRecords.post[k]);
      })
      Object.keys(dataRecords.delivery).forEach((k) => {
        this.chartOptions3.series.push(dataRecords.delivery[k]);
      })
      this.show = true;
    }
  }

</script>
